export const QUESTIONS_TEST = [
    {
        "code": "A1_A",
        "total": 25,
        "chapter1": 8,
        "chapter2": 1,
        "chapter3": 1,
        "chapter4": 0,
        "chapter5": 8,
        "chapter6": 6,
        "important": 1,
        "time": 19,
        "min": 21
    },
    {
        "code": "B1",
        "total": 25,
        "chapter1": 8,
        "chapter2": 1,
        "chapter3": 1,
        "chapter4": 0,
        "chapter5": 8,
        "chapter6": 6,
        "important": 1,
        "time": 19,
        "min": 21
    },
    {
        "code": "B",
        "total": 30,
        "chapter1": 8,
        "chapter2": 1,
        "chapter3": 1,
        "chapter4": 1,
        "chapter5": 9,
        "chapter6": 9,
        "important": 1,
        "time": 20,
        "min": 27
    },
    {
        "code": "C1",
        "total": 35,
        "chapter1": 10,
        "chapter2": 1,
        "chapter3": 2,
        "chapter4": 1,
        "chapter5": 10,
        "chapter6": 10,
        "important": 1,
        "time": 22,
        "min": 32
    },
    {
        "code": "C",
        "total": 40,
        "chapter1": 10,
        "chapter2": 1,
        "chapter3": 2,
        "chapter4": 1,
        "chapter5": 14,
        "chapter6": 11,
        "important": 1,
        "time": 24,
        "min": 36
    },
    {
        "code": "D1_D2_D_BE_C1E_CE_D1E_D2E_DE",
        "total": 45,
        "chapter1": 10,
        "chapter2": 1,
        "chapter3": 2,
        "chapter4": 1,
        "chapter5": 16,
        "chapter6": 14,
        "important": 1,
        "time": 26,
        "min": 41
    }
]